/* eslint-disable camelcase */
import React from 'react';
import Styles from './Banner.module.less';
import { addQueryParamsToUrl, classes } from '../../../lib';
import { Button } from '../../Button';

export type BannerProps = {
    title: string;
    text: string;
    color: string;
    cta: {
        buttonText: string;
        url: string;
    };
    image: React.ReactNode;
    postSlug: string;
};

export const Banner = ({
    title,
    text,
    color,
    cta,
    image,
    postSlug,
}: BannerProps): JSX.Element => {
    const utmParams = {
        utm_source: 'blog',
        utm_campaign: postSlug,
        utm_medium: 'button',
        utm_content: 'banner-blog-cta',
    };
    return (
        <div
            className={classes(
                Styles.banner,
                Styles[color],
                'td-horizontal m-vertical between-bottom g16'
            )}>
            <div className="vertical g16">
                <h2>{title}</h2>
                <p>{text}</p>
                <Button
                    href={addQueryParamsToUrl(cta.url, utmParams)}
                    size="large"
                    type="primary"
                    shape="round">
                    {cta.buttonText}
                </Button>
            </div>
            <div>{image}</div>
        </div>
    );
};
